module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section03_02_beach-photo-33cbe197127a8da398ca2ed0dce9be37.jpg";